import { useEffect, useState } from "react";
import { WifiOff } from "lucide-react";

// Sits under the header whenever the device drops off the network, so a maker
// standing in a field knows why nothing is loading instead of assuming the app
// broke. The service worker keeps the shell rendering; this explains the rest.
export function OfflineBanner() {
  const [offline, setOffline] = useState(
    typeof navigator !== "undefined" && navigator.onLine === false,
  );

  useEffect(() => {
    const goOffline = () => setOffline(true);
    const goOnline = () => setOffline(false);
    window.addEventListener("offline", goOffline);
    window.addEventListener("online", goOnline);
    return () => {
      window.removeEventListener("offline", goOffline);
      window.removeEventListener("online", goOnline);
    };
  }, []);

  if (!offline) return null;

  return (
    <div
      className="sticky top-0 z-[70] flex items-center justify-center gap-2 bg-amber-500 px-3 pb-1.5 text-center text-[12px] font-medium text-amber-950"
      // Same --safe-area-top the Header uses. Without it the bar slides under
      // the status bar and the text sits behind the clock and battery icons.
      style={{ paddingTop: "calc(var(--safe-area-top, 0px) + 0.375rem)" }}
      role="status"
      data-testid="banner-offline"
    >
      <WifiOff className="h-3.5 w-3.5 shrink-0" />
      <span>
        <span className="font-bold">Stoop, there it isn't.</span> You're offline — we'll pick up
        right where you left off.
      </span>
    </div>
  );
}
